/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Branding} from '@core/models';
import { createAction, props } from '@ngrx/store';
import { Client, SuperAdminUser } from '@truckstop-tms/zuum-lib';

export const loadClientsByTenant = createAction(
  '[ClientDetails:TenantClients] Load Clients By Tenant',
  props<{ tenantId: string }>()
);
export const loadClientsByTenantSuccess = createAction(
  '[ClientDetails:TenantClients] Load Clients By Tenant Success',
  props<{ clients: Client[] }>()
);
export const loadClientsByTenantFailure = createAction(
  '[ClientDetails:TenantClients] Load Clients By Tenant Failure',
  props<{ errorMessage: string }>()
);

export const updateClientsByTenantBranding = createAction(
  '[ClientDetails:TenantClients] Load Clients By Tenant Failure',
  props<{ brandings: Branding[] }>()
);

export const loadUsersByTenantId = createAction(
  '[ClientDetails] Load Users By TenantId',
  props<{ tenantId: string }>()
);

export const loadUsersByTenantIdSuccess = createAction(
  '[ClientDetails] Load Users By TenantId Success',
  props<{ users: Partial<SuperAdminUser>[] }>()
);
export const loadUsersByTenantIdFailure = createAction(
  '[ClientDetails] Load Users By TenantId Failure',
  props<{ errorMessage: string }>()
);

export const reset = createAction('[ClientDetails:TenantClients] Reset Clients By Tenant');
